import styled from 'styled-components';

export const NavbarContainer = styled.div`
  background-color: #f3f4f6;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 94px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  margin: 16px 50px;
`;

export const BrandContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Logo = styled.img`
  height: auto;
  width: 200px;
`;

export const NavContainer = styled.nav`
  display: flex;
  gap: 1rem;
  
`;

export const ButtonNav = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
`;

export const TextNav = styled.span<{ active?: boolean, cursor?: string }>`
  font-size: 16px;
  font-weight: 600;
  line-height: 18.77px;
  color: ${(props) => (props.active ? '#2563EB' : '#4B5563')};
  cursor: pointer;
  &:hover {
    color: ${(props) => (props.active ? '' : '#2563EB')};
    text-decoration: ${(props) => (props.active ? 'none' : 'underline')};
    transition: all 0.3s ease-in-out;
    cursor: ${(props) => props.cursor ? props.cursor : props.active && 'auto'};
    text-decoration: none;
  }
`;

export const UserContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
`;

export const UserName = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 18.77px;
  color: #4b5563;
  margin-right: 16px;
`;

export const UserAvatarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
`;

export const UserAvatar = styled.img`
  height: 55px;
  width: 55px;
  border-radius: 50%;
`;

export const SettingsButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
`;

export const UserDropdownContainer = styled.div`
  position: relative;
  display: inline-block;
  
`;

export const UserDropdownContent = styled.div`
  position: absolute;
  right: 0;
  top: 100%;
  background-color: #fff;
  min-width: 190px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1001;
  border-radius: 4px;
  margin-top: 8px;
  text-align: start;
`;

export const UserDropdownItem = styled.div`
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  color: #2563EB;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f3f4f6;
  }
`;

export const UserDropdownDivider = styled.div`
  height: 1px;
  background-color: #e5e7eb;
  margin: 4px 0;
`;

export const UserAvatarCircle = styled.div`
  width: 55px;
  height: 55px;
  background-color: #2563EB;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;  
`;

export const UserAvatarLetter = styled.span`
  color: white;
  font-size: 24px;
  font-weight: bold;
  text-transform: uppercase;
`;
